import { type FC, type JSX, type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

import { useGlobalConfigContext } from '../../../../../global-config'
import { StaticImage } from '../../../../../image'
import { urlResolverScanEprescription } from '../../../../../url-handling'
import ImgMarketingBanner from '../../../../images/ImgMarketingBanner.png'

const erxLandingPageTextAccent = (text: ReactNode[]): JSX.Element => (
  <span className="whitespace-nowrap italic text-dark-accent">{text}</span>
)

export const ErxBonusLandingPageMarketingBanner: FC = () => {
  const globalConfig = useGlobalConfigContext()

  return (
    <div className="mt-10 rounded-2xl bg-light-brand-high p-4 tablet:px-6 tablet:py-0">
      <div className="flex flex-col gap-4 tablet:flex-row">
        <div className="self-center tablet:self-end">
          <StaticImage
            alt="erx-marketing-banner"
            className="max-w-max"
            height={132}
            src={ImgMarketingBanner}
            width={254}
          />
        </div>
        <div className="flex w-full flex-col justify-between gap-4 self-center tablet:flex-row">
          <div className="px-5 tablet:px-0">
            <h2 className="text-2xl font-medium">
              <FormattedMessage
                id="deErx.heroHeader.eRezept.title"
                values={{
                  accentuate: erxLandingPageTextAccent,
                }}
              />
            </h2>
            <p className="text-l font-medium">
              <FormattedMessage id="deErx.oldBonus.MarkertingBanner.description" />
            </p>
          </div>
          <div>
            <Button<'a'>
              className="w-full"
              href={urlResolverScanEprescription(globalConfig)}
              slots={{ root: 'a' }}
            >
              <FormattedMessage id="deErx.oldBonus.heroHeader.eRezept.btn" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
